import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Button, Label, Input, Form } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { updateOperator, getOperators } from "../../slices/operators/thunk";

const StatusUpdateModal = ({ isOpen, toggle, operator }) => {
    const dispatch = useDispatch();
    const { actionLoading } = useSelector((state) => state.Operators);
    const [status, setStatus] = useState("true"); // Use string for select value

    useEffect(() => {
        if (operator) {
            setStatus(operator.isActive ? "true" : "false");
        }
    }, [operator, isOpen]);

    const handleUpdate = async () => {
        if (!operator) return;

        const updateData = {
            isActive: status === "true"
        };

        const result = await dispatch(updateOperator({ id: operator._id, data: updateData }));

        if (result.payload && (result.payload.success || result.payload.status === 1)) {
            dispatch(getOperators({ page: 1, limit: 10 }));
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="md">
            <ModalHeader toggle={toggle} className="border-bottom-0"></ModalHeader>
            <ModalBody className="py-3 px-4">
                <div className="text-center mb-4">
                    <div className="avatar-md mx-auto mb-3">
                        <div className="avatar-title bg-light rounded-circle text-primary display-6">
                            <i className="ri-user-settings-line"></i>
                        </div>
                    </div>
                    <h5 className="mb-1">{operator?.username}</h5>
                    <p className="text-muted mb-0">{operator?.email}</p>
                </div>

                <Form>
                    <div className="mb-4">
                        <Label className="form-label">Operator Status</Label>
                        <Input
                            type="select"
                            className="form-select mb-3"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </Input>
                    </div>

                    <div className="d-flex gap-2 justify-content-center mt-3">
                        <Button color="light" onClick={toggle} className="w-50">Cancel</Button>
                        <Button color="success" onClick={handleUpdate} disabled={actionLoading} className="w-50">
                            {actionLoading ? "Updating..." : "Update Status"}
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default StatusUpdateModal;
